import React from "react";
import { Box, RadioGroup } from "@mui/material";
import { DotLegalHeader, DotLegalRadioButton } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { YesNoAnswer } from "../../../incidentLog/IncidentLogDialog.types.ts";

export interface IncidentLogYesNoAnswerFieldProps {
    label: string;
    answer?: YesNoAnswer | null;
    onChange: (answer: YesNoAnswer) => void;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogYesNoAnswerField(props: IncidentLogYesNoAnswerFieldProps) {
    const { translateString } = useTranslation();

    return (
        // Same spacing as IncidentLogYesNoUnknownAnswerField: the DotLegal field below brings its own top margin.
        <Box sx={{ mt: 2 }}>
            <DotLegalHeader marginBottom={0} headerStyle={"small"}>
                {props.label}
            </DotLegalHeader>
            <RadioGroup row value={props.answer ?? null} onChange={(e) => props.onChange(Number((e.target as HTMLInputElement).value) as YesNoAnswer)}>
                <DotLegalRadioButton value={YesNoAnswer.Yes} labelPlacement="end" label={translateString("yes")} disabled={props.disabled} />
                <DotLegalRadioButton value={YesNoAnswer.No} labelPlacement="end" label={translateString("no")} disabled={props.disabled} />
            </RadioGroup>
            {props.errorText && <Box sx={(theme) => ({ fontSize: theme.typography.pxToRem(12), color: theme.palette.error.main })}>{props.errorText}</Box>}
        </Box>
    );
}

export default IncidentLogYesNoAnswerField;
